// Handle postMessage requests from parent window
window.addEventListener('message', function(event) {
  // Only accept messages from trusted origins (you can customize this list)
  const allowedOrigins = ['*']; // Allow all origins for now, you can restrict this

  if (allowedOrigins.includes('*') || allowedOrigins.includes(event.origin)) {
    if (event.data && event.data.action === 'init-iframe-styles') {
      // Add iframe class to html element to trigger CSS styles
      document.documentElement.classList.add('iframe');

      // Send confirmation back to parent
      event.source.postMessage({
        action: 'init-iframe-styles',
      }, event.origin);
    }
  }
});
